<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-2">
          <v-img
            :src="appLogo"
            max-height="160px"
            max-width="160px"
            alt="logo"
            contain
            class="me-3"
          ></v-img>
        </v-card-title>

        <!-- title -->
        <v-card-text>
          <p class="mb-2">
            Por favor, inicia sesión con tus credenciales.
          </p>
        </v-card-text>
        <!-- login form -->
        <v-card-text>
          <v-form
            ref="loginForm"
            @submit.prevent="handleFormSubmit"
          >
            <v-text-field
              v-model="email"
              outlined
              label="Correo electrónico"
              placeholder="correo@midominio.com"
              hide-details
              class="mb-3"
              :rules="[validators.validateRequired, validators.validateEmail]"
              :prepend-icon="icons.mdiEmail"
            ></v-text-field>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="Contraseña"
              placeholder="············"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              :prepend-icon="icons.mdiLock"
              :rules="[validators.validateRequired]"
              hide-details
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>
            <v-btn
              type="submit"
              block
              color="primary"
              class="mt-6"
            >
              Iniciar Sesión
            </v-btn>
          </v-form>
        </v-card-text>

        <!-- create new account  -->
        <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
          <span class="me-2">
            ¿Eres nuevo en la plataforma? Para solicitar tu usuario, por favor contacta a tu supervisor o a tu contato
            corporativo.
          </span>
        </v-card-text>

        <!-- divider -->
        <v-card-text class="d-flex align-center mt-2">
          <v-divider></v-divider>
          <span class="me-2">Powered by <a
            href="http://mindnet.com.mx"
            target="blank"
          >MindNet.Com.Mx</a></span>
        </v-card-text>
      </v-card>
    </div>

    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
    />

    <!-- tree -->
    <v-img
      class="auth-tree"
      height="220"
      src="@/assets/images/misc/tree.png"
    ></v-img>

    <!-- tree  -->
    <v-img
      class="auth-tree-3"
      width="220"
      src="@/assets/images/misc/tree-3.png"
    ></v-img>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiEyeOutline, mdiEyeOffOutline, mdiEmail, mdiLock } from '@mdi/js'
import { ref, getCurrentInstance } from '@vue/composition-api'
import { validateRequired, validateEmail } from '@core/utils/validation'
import { useRouter } from '@core/utils'
import themeConfig from '@themeConfig'
import store from '@/store'

export default {
  setup() {
    localStorage.setItem('accessToken', null)
    localStorage.setItem('userData', null)

    // Template Ref
    const loginForm = ref(null)

    const vm = getCurrentInstance().proxy
    const { router } = useRouter()

    const isPasswordVisible = ref(false)

    const email = ref('')
    const password = ref('')

    const handleFormSubmit = () => {
      const isFormValid = loginForm.value.validate()

      if (!isFormValid) return

      /*
        1. Make HTTP request to get accessToken
        2. Store received token in localStorage for future use
        3. Make another HTTP request for getting user information
        4. On successful response of user information redirect to home page

        ? We have use promise chaining to get user data from access token
        ? Promise Chaining: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining
      */
      store.dispatch('auth/apiLogin', { email: email.value, password: password.value })
        .then(result => {
          if (!result.success) {
            return
          }

          const { accessToken } = result.data
          const { userKey } = result.data

          // ? Set access token in localStorage so axios interceptor can use it
          // Axios Interceptors: https://github.com/axios/axios#interceptors
          localStorage.setItem('accessToken', accessToken)

          store.dispatch('users/apiCall', {
            mode: 'select',
            request: {
              key: userKey,
            },
          }).then(response => {
            if (!response.success) {
              return
            }
            const user = response.data

            // const { ability: userAbility } = user

            // // Set user ability
            // // ? https://casl.js.org/v5/en/guide/intro#update-rules
            // vm.$ability.update(userAbility)

            // // Set user's ability in localStorage for Access Control
            // localStorage.setItem('userAbility', JSON.stringify(userAbility))

            // We will store `userAbility` in localStorage separate from userData
            // Hence, we are just removing it from user object
            // delete user.ability

            // ### Patch #####################################################
            const userAbility = [{
              action: 'manage',
              subject: 'all',
            }]
            vm.$ability.update(userAbility)
            localStorage.setItem('userAbility', JSON.stringify(userAbility))

            // ###############################################################

            // Set user's data in localStorage for UI/Other purpose
            localStorage.setItem('userData', JSON.stringify(user))

            // On success redirect to home
            router.push('/')
          })
        })
    }

    return {
      handleFormSubmit,
      isPasswordVisible,
      email,
      password,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiEmail,
        mdiLock,
      },
      validators: {
        validateRequired,
        validateEmail,
      },

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Template Refs
      loginForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>
